export default __webpack_public_path__ + "static/media/posong.e14ca6b8.png";